import React from 'react';

import { ContainerWithMaxWidth } from '@/core/components/ContainerWithMaxWidth';
import { useRouterContext } from '@/core/lib/router/router.context';
import Routes from '@/core/lib/router/routes';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

export interface PreFooterProps {}

const PreFooter: React.FC<PreFooterProps> = () => {
  const { t } = useTranslationContext(['common']);
  const { Link } = useRouterContext();

  return (
    <section
      style={{
        backgroundImage: 'url(/assets/preFooter/donnons-filigrane.png)',
      }}
      className="bg-[#1F0A57] bg-50% lg:bg-contain"
    >
      <ContainerWithMaxWidth>
        <div className="flex w-full items-center py-8 xl:py-0">
          <img src="/assets/preFooter/app-promo.png" alt={t('components.pre-footer.app-promo-alt', { ns: 'common' })} className="hidden self-end xl:block" />
          <div className="grow space-y-3 lg:mr-7 xl:ml-8">
            <p className="text-20 font-semibold text-content-button-primary lg:text-40">{t('components.pre-footer.title', { ns: 'common' })}</p>
            <p className="hidden text-24 text-content-button-primary lg:block">{t('components.pre-footer.text', { ns: 'common' })}</p>
            <div className="hidden space-x-6 lg:flex">
              <img src="/assets/preFooter/apple-notes.png" alt={t('components.pre-footer.apple-notes-alt', { ns: 'common' })} />
              <img src="/assets/preFooter/android-notes.png" alt={t('components.pre-footer.android-notes-alt', { ns: 'common' })} />
            </div>
            <div className="flex flex-col space-y-3 md:flex-row md:space-x-7 md:space-y-0 lg:hidden">
              <div className="flex items-center space-x-3">
                <Link href={new Routes.ExternalRoute('appStore')} target="_blank" className="w-35">
                  <img src="/assets/socialNetwork/app-store.png" alt={t('social-network.app-store-alt', { ns: 'common' })} />
                </Link>
                <img src="/assets/preFooter/apple-note-without-logo.png" alt={t('components.pre-footer.android-notes-alt', { ns: 'common' })} className="h-5" />
              </div>
              <div className="flex items-center space-x-3">
                <Link href={new Routes.ExternalRoute('playStore')} target="_blank" className="w-35">
                  <img src="/assets/socialNetwork/google-play.png" alt={t('social-network.play-store-alt', { ns: 'common' })} />
                </Link>
                <img src="/assets/preFooter/android-note-without-logo.png" alt={t('components.pre-footer.android-notes-alt', { ns: 'common' })} className="h-5" />
              </div>
            </div>
          </div>
          <img src="/assets/appQRcode.png" alt={t('components.pre-footer.qr-code-alt', { ns: 'common' })} className="hidden lg:block" />
        </div>
      </ContainerWithMaxWidth>
    </section>
  );
};

export default PreFooter;
